import React from 'react';
import "./FindUs.css";
import guwahatiImg from "./media/prime3d2.png"; // put your image here

export default function FindUs() { 
  return (
    
    <section className="findus-section">
          
        
      <div className="findus-left">
        <img src={guwahatiImg} alt="Guwahati" className="findus-img" />
      
      </div>

      <div className="findus-right">
      <iframe
  title="PrimeMax Map"
  className="findus-map"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3580.6507757865743!2d91.77368657541425!3d26.175500577094255!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x375a597b066e103f%3A0xbdc3b232fa3cf622!2sPrimeMax%20Dental%20Clinic!5e0!3m2!1sen!2sin!4v1764872513264!5m2!1sen!2sin"
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>
      </div>
    </section>
  );
}
